import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import AksCalc from '../components/calculators/AksCalc'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import { generateBreadcrumbList } from '../utils/schemaHelpers'

export default function AksCalculatorPage() {
  return (
    <>
      <Helmet>
        <title>Azure Kubernetes Service (AKS) Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure AKS costs in GBP for UK South. Free vs Standard vs Premium control plane, node pool sizing, Uptime SLA, Spot nodes, and Load Balancer egress." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/aks" />
        <meta property="og:title" content="Azure AKS Cost Calculator UK" />
        <meta property="og:description" content="AKS pricing in GBP for UK South — model control plane tiers, Uptime SLA, node pools, and Spot nodes to surface the hidden billing traps." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/aks" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'Azure AKS Calculator', url: '/aks', position: 2 },
        ]))}</script>
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure Kubernetes Service Cost Calculator',
          description: 'Independent AKS pricing calculator for UK South — model control plane tiers, Uptime SLA, node pools, Spot nodes, and Load Balancer egress in GBP.',
          url: 'https://www.azure-calc.co.uk/aks',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure Kubernetes Service (AKS) Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Free / Standard / Premium tiers · Uptime SLA · Spot nodes · LB egress
          </p>
        </div>

        <AksCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>Related guides</h2>
          <Link
            to="/guides/azure-aks-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold group-hover:text-[#0078d4] transition-colors" style={{ color: 'var(--text-secondary)' }}>Azure AKS Pricing Guide UK</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Control plane tiers, Uptime SLA, Spot nodes, egress billing, and node pool sizing patterns</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
